import {useEffect, useState} from "react"
import {Project} from "./types"
import {getServiceHubToken} from "./serviceHubApi"

// Equivalent to staleTime: Infinity — fetched once per session
let cachedProjects: Project[] | null = null

export const useProjects = (open: boolean) => {
    const [projects, setProjects] = useState<Project[]>(cachedProjects ?? [])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (!open || cachedProjects !== null) return

        setIsLoading(true)
        setError(null)

        const load = async () => {
            const token = await getServiceHubToken()
            const res = await fetch(
                `${process.env.REACT_APP_SERVICE_HUB_URL}/api/v1/projects/self`,
                {headers: {Authorization: `Bearer ${token}`}}
            )
            if (!res.ok) throw new Error(`Failed to fetch projects (${res.status})`)
            const json = await res.json()
            return json.data as Project[]
        }

        load()
            .then((data) => {
                cachedProjects = data
                setProjects(data)
            })
            .catch((e: Error) => {
                // eslint-disable-next-line no-console
                console.error("[all-apps] failed to load projects:", e)
                setError(e.message)
            })
            .finally(() => setIsLoading(false))
    }, [open])

    return {projects, isLoading, error}
}
